import {getAiPromoCountdown} from './getAiPromoStartLabel';

/**
 * Что показать в плашке отсчета ИИ-лобби до старта матча — тот же отсчет, что
 * на кнопке главного меню и в промо-модалке (getAiPromoCountdown): «Сбор
 * игроков 5 мин 0 сек» до 21:00 и «Старт через 7 мин 5 сек», когда сервер
 * взвел отсчет. Срок вышел, а сервер еще запускает фазу банов (starting), —
 * отсчет держится на нуле, плашка не пропадает.
 *
 * Фаза банов и выбор фракций идут со своим отсчетом и прежними подписями
 * (factionBanDeadlineAt / rankMatchStartAt в LobbyPage) — тогда здесь null.
 * Время считается по часам сервера (now = Date.now() + serverTimeDelta).
 *
 * @param {Object} params
 * @param {Object} params.lobby - private.lobby (isAiMatch, aiPromo, метки фаз)
 * @param {number} params.now - время сервера, мс
 * @returns {null|{kind: string, targetAt: number, prefix: string, timeText: string}}
 */
export const getAiLobbyCountdownState = ({lobby, now}) => {
  if (!lobby?.isAiMatch) return null;
  if (lobby.factionBanDeadlineAt || lobby.rankMatchStartAt) return null;
  return getAiPromoCountdown(lobby.aiPromo, {now});
};
